import React, { Component } from "react";
import DetailsTelahMengisi from "../../component/detail-kebijakan/DetailsTelahMengisi";
class YangMengisi extends Component {
    render(){
        return(
            <>
                <DetailsTelahMengisi/>
            </>
        )
    }
}
export default YangMengisi;